import { AppRouteRecordRaw } from '../types';
import { PARTNER_FEATURE_FLAGS } from '@/constants/partner-features';

const Body = () => import('@/components/body.vue');
const DriverAccountList = () =>
  import('@/pages/partner/driver-account-management/list/DriverAccountList.vue');
const DriverAccountDetail = () =>
  import('@/pages/partner/driver-account-management/detail/DriverAccountDetail.vue');
const DriverAccountUpdate = () =>
  import('@/pages/partner/driver-account-management/update/DriverAccountUpdate.vue');
const DriverAccountCreate = () =>
  import('@/pages/partner/driver-account-management/create/DriverAccountCreate.vue');

export const driverAccountManagementRoutes: AppRouteRecordRaw[] = [
  {
    path: '/driver-account-management',
    component: Body,
    // Switched on per partner via Partner Administration → Partner Features
    // ("Driver / Account Management"). The guard reads the first matched route
    // with requirements, so the parent meta covers every child page.
    meta: {
      requiresAuth: true,
      breadcrumb: 'Driver Account Management',
      requiresPartnerFeature: PARTNER_FEATURE_FLAGS.DRIVER_ACCOUNT_MANAGEMENT,
    },
    children: [
      {
        path: 'api-partner/accounts/list',
        name: 'DriverAccountList',
        component: DriverAccountList,
        meta: {
          title: 'Driver/Account List | ryd Portal',
          breadcrumb: 'Driver/Account List',
        },
      },
      {
        path: 'api-partner/accounts/details/:id',
        name: 'DriverAccountDetail',
        component: DriverAccountDetail,
        meta: {
          title: 'Driver/Account Detail | ryd Portal',
          breadcrumb: 'Driver/Account Detail',
        },
      },
      {
        path: 'api-partner/accounts/create',
        name: 'DriverAccountCreate',
        component: DriverAccountCreate,
        meta: {
          title: 'Create Driver/Account | ryd Portal',
          breadcrumb: 'Create Driver/Account',
        },
      },
      {
        path: 'api-partner/accounts/update/:id',
        name: 'DriverAccountUpdate',
        component: DriverAccountUpdate,
        meta: {
          title: 'Driver/Account Update | ryd Portal',
          breadcrumb: 'Driver/Account Update',
        },
      },
      {
        path: 'api-partner/accounts/details',
        name: 'DriverAccountDetailEntry',
        component: DriverAccountDetail,
        meta: {
          title: 'Driver/Account Detail | ryd Portal',
          breadcrumb: 'Driver/Account Detail',
        },
      },
      {
        path: 'api-partner/accounts/update',
        name: 'DriverAccountUpdateEntry',
        component: DriverAccountUpdate,
        meta: {
          title: 'Driver/Account Update | ryd Portal',
          breadcrumb: 'Driver/Account Update',
        },
      },
    ],
  },
];
